<script>
  import {createEventDispatcher} from 'svelte';
  import Loader from './Loader.svelte'

  const dispatch = createEventDispatcher();

  export let show = false;
  export let title = "Confirmation";
  export let desc = "";
  export let data = null;
  export let confirmBtn = "Confirm";
  export let cancelBtn = "Cancel"
  export let loaderText = null;

  let dialogEl;

  function updateDialogState(show) {
    if (!dialogEl) return;

    if (show) dialogEl.showModal();
    else dialogEl.close();
  }

  $: updateDialogState(show);
</script>

<section>
  <dialog class="nes-dialog" bind:this={dialogEl}>
    <Loader text={loaderText} />

    <p class="title">{title}</p>
    <p>{desc}</p>
    <menu class="dialog-menu">
      <button class="nes-btn is-error" on:click={() => dispatch('confirm', data)}>{confirmBtn}</button>
      <button class="nes-btn" on:click={() => dispatch('cancel', data)}>{cancelBtn}</button>
    </menu>
  </dialog>
</section>

<style>
  .nes-dialog {
      max-width: 36rem;
  }
</style>